// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "chartjs" + ".js?v=" + "6acc924e528bda6924ec" + "";
};